import axios from 'axios'

export const state = {
  warehouses: {},
}

export const getters = {
  listWarehouses(state) {
    return state.warehouses
  },
}

export const mutations = {
  SET_WAREHOUSES(state, warehouses) {
    state.warehouses = warehouses
  },
}

export const actions = {
  getWarehouses({ commit }, params = {}) {
    return axios.get(`/warehouses/search`, { params })
  },
  getCacheWarehouses({ commit }, params = {}) {
    return axios.get(`/warehouses/search`, { params }).then(({ data }) => {
      return commit('SET_WAREHOUSES', data)
    })
  },
  getWarehouse({ commit }, id) {
    return axios.get(`/warehouses/${id}`)
  },
  createWarehouse({ commit }, data) {
    return axios.post('/warehouses', data)
  },
  updateWarehouse({ commit }, warehouse) {
    return axios.put(`/warehouses/${warehouse.id}`, warehouse)
  },
  exportWarehousesCsv({commit}, params = {}) {
    return axios.get('/warehouses/export', {params});
  },
  importWarehouses({commit}, params = {}) {
    const formData = new FormData()
    formData.append('file', params.file, params.file.name)
    formData.append('type', params.type)
    formData.append('force_save', params.force_save)
    formData.append('download_error', params.download_error)
    const responseType = params.download_error ? 'blob' : 'json'
    return axios.post('/warehouses/import', formData, { responseType: responseType })
  },
  downloadImportWarehousesTemplate({ commit }, params = {} ) {
    return axios.get(`/import/warehouse/download-template`, { responseType: 'blob' })
  },
}
